var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "header", staticClass: "yqg-header" }, [
    _c("div", { staticClass: "buffer" }),
    _vm._v(" "),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container-wrappper" }, [
      _c("div", { staticClass: "container" }, [
        _c("img", {
          staticClass: "logo",
          attrs: { src: require("./img/logo-white.png") },
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "active-logo",
          attrs: { src: require("./img/logo.png") },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "btn-group" }, [
          _c(
            "a",
            { staticClass: "btn tel", attrs: { href: "tel:0755-89542206" } },
            [
              _c("span", { staticClass: "sm-hide" }, [
                _vm._v("客户服务及征信异议受理热线：0755-89542206"),
              ]),
            ]
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }